import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import s from "./EventsInAzerbaijan.module.scss";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getEventsInAzerbaijan,
  getPartnerBuyers,
  getPartnerSuppliers,
} from "../../redux/ApplicationSlice";
import { Link } from "react-router-dom";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import moment from "moment/moment";

const EventsInAzerbaijan = () => {
  const { t } = useTranslation();
  const events = useSelector((state) => state.application.eventsInAzerbaijan);
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();

  useEffect(() => {
    dispatch(getEventsInAzerbaijan());
  }, [dispatch]);

  console.log(events, "events in azerbaijan");

  return (
    <div>
      {width > 1130 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <h2 className={s.h2}>{t("Мероприятия в Азербайджане")}</h2>
        <div className={s.partners}>
          {Array.isArray(events) && events.length > 0 ? (
            events.map((it) => (
              <div className={s.partner_item}>
                <div className={s.img}>
                  <div className={s.date}>
                    {moment(it?.published_date).format("DD.MM.YYYY")}
                  </div>
                  <img src={it?.photos[0]?.image} className={s.image} />
                </div>
                <div className={s.text}>
                  <div className={s.title}>{it?.title}</div>

                  <div className={s.description}>{it?.description}</div>

                  <div className={s.site}>
                    <Link to={`/event/${it.id}`} className={s.link}>
                      {t("Подробнее")} <ArrowRightOutlined />
                    </Link>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className={s.empty}>{t("Пока нет мероприятий")} ...</div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EventsInAzerbaijan;
